if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

          change_slider_location();

		}

		updateCartQty(item, newQty){

			let alert = null;
 
			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});
          const current_this = this;

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
                  console.log(response);
                  var gift_array = [];
                            var cart_product_array = [];
                            var giftproduct1 = parseInt(first_giftproduct_id),
                             giftproduct2 = parseInt(second_giftproduct_id);
                            response.items.forEach(function(item) {
                              var item_id = item.id;
                              cart_product_array.push(item_id);
                            });

                  console.log(response.total_price+' > '+first_gift_product_available_value);
                  console.log(response.total_price+' >= '+second_gift_product_available_value);
                     if(response.total_price >= second_gift_product_available_value && second_gift_product_available_value != 0){
                       console.log('1');
                        if(second_giftproduct_id != ''){
                          if ($.inArray(giftproduct2, cart_product_array) == -1) {
                            giftpurchase_productadd(giftproduct2); 
                          } 
                        }
                       
                        if(first_giftproduct_id != ''){
                          if ($.inArray(giftproduct1, cart_product_array) == -1) {
                            console.log($.inArray(giftproduct1, cart_product_array));
                            setTimeout(function(e) {
                             giftpurchase_productadd(giftproduct1); 
                            },1000);
                          } 
                        }
                      }else if(response.total_price >= first_gift_product_available_value && first_gift_product_available_value != 0){
                       console.log('2');
                        if(first_giftproduct_id != ''){
                          if ($.inArray(giftproduct1, cart_product_array) == -1) {
                            giftpurchase_productadd(giftproduct1); 
                          } 
                        }else{}

                        if(second_giftproduct_id != ''){
                          if ($.inArray(giftproduct2, cart_product_array) > -1) {
                            giftpurchase_productremove(giftproduct2); 
                          } 
                        }else{}
                       
                      }else if(response.total_price < first_gift_product_available_value && response.total_price < second_gift_product_available_value && response.total_price != 0){
                        // if(first_giftproduct_id!= '' && second_giftproduct_id != ''){
                        //   console.log($.inArray(giftproduct1, cart_product_array));
                        //   console.log($.inArray(giftproduct2, cart_product_array));
                        //   if ($.inArray(giftproduct1, cart_product_array) == 0 && $.inArray(giftproduct2, cart_product_array) == 0) {
                        //     console.log('11');
                        //     gift_array.push(first_giftproduct_id, second_giftproduct_id);
                        //     var productval = gift_array.shift();
                        //     giftpurchase_productremove(productval); 
                        //   }
                        //   else if ($.inArray(giftproduct1, cart_product_array) <= 1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                        //     console.log('12');
                        //     giftpurchase_productremove(giftproduct1); 
                        //   } else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                        //     console.log('13');
                        //     giftpurchase_productremove(giftproduct2); 
                        //   }
                        // }
                        // else 
                        console.log(first_giftproduct_id,second_giftproduct_id);
                        gift_array.push(first_giftproduct_id, second_giftproduct_id);
                        var productval = gift_array.shift();
                        if(first_giftproduct_id != ''){
                          console.log($.inArray(giftproduct1, cart_product_array) <= 1);
                          if ($.inArray(giftproduct1, cart_product_array) > -1) {
                            giftpurchase_productremove(productval); 
                          } 
                        }
                       if(second_giftproduct_id != ''){
                         console.log($.inArray(giftproduct2, cart_product_array));
                          if ($.inArray(giftproduct2, cart_product_array) > -1) {
                            giftpurchase_productremove(productval); 
                          } 
                        }
                      }else if(response.total_price < first_gift_product_available_value && response.total_price != 0){
                       console.log('4');
                        if(first_giftproduct_id != ''){
                          console.log($.inArray(giftproduct1, cart_product_array));
                          if ($.inArray(giftproduct1, cart_product_array) > -1) {
                            giftpurchase_productremove(giftproduct1); 
                          } 
                        }
                      }else if(response.total_price > first_gift_product_available_value && response.total_price < second_gift_product_available_value){
                       console.log('5');
                       if(first_giftproduct_id != ''){
                          if ($.inArray(giftproduct1, cart_product_array) == -1) {
                            console.log('sa');
                            giftpurchase_productadd(giftproduct1); 
                          } 
                        }else{}
                        if(second_giftproduct_id != ''){
                          if ($.inArray(giftproduct2, cart_product_array) > -1) {
                            giftpurchase_productremove(giftproduct2); 
                          } 
                        }
                       
                      }else if(response.total_price == 0){
                       console.log('6');
                       if(first_giftproduct_id!= '' && second_giftproduct_id != ''){
                          if ($.inArray(giftproduct1, cart_product_array) > -1 && $.inArray(giftproduct2, cart_product_array) > -1) {
                            gift_array.push(first_giftproduct_id, second_giftproduct_id);
                            var productval = gift_array.shift();
                            giftpurchase_productremove(productval); 
                          }
                          else if ($.inArray(giftproduct1, cart_product_array) > -1 && $.inArray(giftproduct2, cart_product_array) == -1) {
                            giftpurchase_productremove(giftproduct1); 
                          } else if ($.inArray(giftproduct1, cart_product_array) == -1 && $.inArray(giftproduct2, cart_product_array) <= 1) {
                            giftpurchase_productremove(giftproduct2); 
                          }
                        }else if(first_giftproduct_id != '' && second_giftproduct_id == ''){
                          if ($.inArray(giftproduct1, cart_product_array) > -1) {
                            giftpurchase_productremove(giftproduct1); 
                          } 
                        }else if(first_giftproduct_id == '' && second_giftproduct_id != ''){
                          if ($.inArray(giftproduct2, cart_product_array) > -1) {
                            giftpurchase_productremove(giftproduct2); 
                          } 
                        }
                      }

                  function giftpurchase_productadd(giftpurchase_product){
                          $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: {
                              quantity: 1,
                              id: giftpurchase_product,
                              properties: {
                                'Gift': 'OFFERT'
                               }
                            },
                            dataType: 'json',
                            success: function(response) {
                              console.log(giftpurchase_product,"giftpurchase_product")
                                  fetch('?section_id=helper-cart')
                                  .then((response) => response.text())
                                  .then((responseText) => {
                                    const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html');
                					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                    const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
                					const cartItems = document.getElementById('AjaxCartForm');
                					cartItems.innerHTML = cartFormInnerHTML;
                					cartItems.ajaxifyCartItems();
                
                					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                					});
                					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                					});
                
                					if ( alert !== null ) {
                						this.form.prepend(alert);
                					} 
                
                					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                							console.log('dsd');
                                  
                					const event = new Event('cart-updated');
                					current_this.dispatchEvent(event);
                                    change_slider_location();
                                  })
                                  .catch((e) => {
                                    console.error(e); 
                                  });
                            },
                            error: function() {
                            }
                          });
                    }

                   function giftpurchase_productremove(giftpurchase_product){
                          console.log(giftpurchase_product);
                          $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: {
                              quantity: 0,
                              id: giftpurchase_product
                            },
                            dataType: 'json',
                            success: function(response) {
                              console.log(gift_array,response);
                              if(gift_array.length > 0){
                                var productval = gift_array.shift();
                                giftpurchase_productremove(productval); 
                              }else{
                                 fetch('?section_id=helper-cart')
                                  .then((response) => response.text())
                                  .then((responseText) => {
                                    const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html');
                					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                    const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
                					const cartItems = document.getElementById('AjaxCartForm');
                					cartItems.innerHTML = cartFormInnerHTML;
                					cartItems.ajaxifyCartItems();
                
                					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                					});
                					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                					});
                
                					if ( alert !== null ) {
                						this.form.prepend(alert);
                					} 
                
                					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                							console.log('dsd');
                                  
                					const event = new Event('cart-updated');
                					current_this.dispatchEvent(event);
                                    change_slider_location();
                                  })
                                  .catch((e) => {
                                    console.error(e); 
                                  });
                              }
                            },
                            error: function() {
                              console.log(gift_array,response);
                              if(gift_array.length > 0){
                                var productval = gift_array.shift();
                                giftpurchase_productremove(productval); 
                              }else{
                                 fetch('?section_id=helper-cart')
                                  .then((response) => response.text())
                                  .then((responseText) => {
                                    const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html');
                					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                                    const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
                					const cartItems = document.getElementById('AjaxCartForm');
                					cartItems.innerHTML = cartFormInnerHTML;
                					cartItems.ajaxifyCartItems();
                
                					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                					});
                					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                					});
                
                					if ( alert !== null ) {
                						this.form.prepend(alert);
                					} 
                
                					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                							console.log('dsd');
                                  
                					const event = new Event('cart-updated');
                					current_this.dispatchEvent(event);
                                    change_slider_location();
                                  })
                                  .catch((e) => {
                                    console.error(e); 
                                  });
                              }
                            }
                          });
                    }

                    change_slider_location();
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
                    const newupdatecartPrice = sectionInnerHTML.getElementById('AjaxCartForm').dataset.carttotal;
					const cartItems = document.getElementById('AjaxCartForm');
                  console.log(sectionInnerHTML.getElementById('AjaxCartForm'));
                  console.log(cartItems,'cartItems')
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							console.log('dsd');
                  
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

// first_giftproduct_id
$.getJSON('/cart.js',function(cart) {
   var items = cart.items;
   var total = cart.total_price; 
   console.log(items); 
   var item_count_first = 0,item_count_second = 0;
   for(var i = 0; i < items.length; i++){
     var item_id = items[i].id;
     if(item_id == first_giftproduct_id){
       if(cart.total_price < first_gift_product_available_value){
         console.log('removed');
         $.ajax({
           type: "post",
           url: "/cart/change.js",
           data:{
              id:  item_id,
              quantity: 0 
           },
           dataType: "json",
           success: function(e) {
             render_cart();
           },
           error: function(e) {
             render_cart() 
           }  
         })  
       }
       item_count_first = 999;
     }else if(item_id == second_giftproduct_id && second_giftproduct_id != ''){
       if(cart.total_price < second_gift_product_available_value){
         console.log('removed');
         $.ajax({
           type: "post",
           url: "/cart/change.js",
           data:{
              id:  item_id,
              quantity: 0 
           },
           dataType: "json",
           success: function(e) {
             render_cart();
           },
           error: function(e) {
             render_cart() 
           }  
         })  
       }
       item_count_second = 999
     }    
   }
   
})

function render_cart() {
   fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			var cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			var cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			var cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
           setTimeout(function(e) {
             change_slider_location();
           },500)   
           setTimeout(function(e) {
             change_slider_location();
           },1000)   
		})
}



if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
          change_slider_location();
		})

	}

}

$(window).on('load',function(e) {
  change_slider_location();
})

function change_slider_location() {
  var slider_nav = $('cart-recommendations .css-slider-navigation-container');
  $('cart-recommendations .cart_recommendations_header-arrow').html(slider_nav)
}